// PrivateRoute.js
import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const hasSession = !!localStorage.getItem('dfp/session')
      const isRootPath = props.location.pathname === '/'
      if (hasSession) {
        return isRootPath ? (
          <Redirect
            to={{ pathname: '/property-data', search: props.location.search }}
          />
        ) : (
          <Component {...props} />
        )
      }
      return <Redirect to='/home' />
    }}
  />
)

export default PrivateRoute
